module.exports = __webpack_public_path__ + "img/404.85064a97.svg";